import { render, staticRenderFns } from "./AppManage.vue?vue&type=template&id=989cc162";
import script from "./AppManage.vue?vue&type=script&lang=js";
export * from "./AppManage.vue?vue&type=script&lang=js";
import style0 from "./AppManage.vue?vue&type=style&index=0&id=989cc162&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;